import React from 'react';
import NewAuthorisationBatchVM from './NewAuthorisationBatchVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import BatchCriteria from './BatchCriteria';
import CreateLetterAuthorisationBatchCommand from '../../../Models/LetterAuthorisation/Commands/CreateLetterAuthorisationBatchCommand';
import { ReportType } from "../../../Models/LetterAuthorisation/ReportType";

interface INewAuthorisationBatchProps {
    viewModel: NewAuthorisationBatchVM;
    onBackClicked: () => void;
    onBatchCreated: (batchId: number) => void;
}

@observer
export default class NewAuthorisationBatch extends React.Component<INewAuthorisationBatchProps> {

    constructor(props: INewAuthorisationBatchProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        const hasDescriptions = viewModel.suggested.some(item => item.description);

        return (
            <div>
                <Neo.Card title="New authorisation batch" icon="file">
                    <div className="mb-4">
                        <Neo.Button variant="light" icon="arrow-left" onClick={() => this.props.onBackClicked()}>Back</Neo.Button>
                    </div>

                    <BatchCriteria criteria={viewModel.criteria} autoRunner={viewModel.criteriaAutoRunner} />
                </Neo.Card>

                <Neo.Card>
                    {!viewModel.criteria.reportType && 
                        <Neo.Alert variant="warning" className="mb-0">
                            Please select a report type.
                        </Neo.Alert>}

                    {viewModel.criteria.reportType && viewModel.suggested.length > 0 &&
                        <NeoGrid.Grid items={viewModel.suggested}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.reportDate} />
                                    <NeoGrid.Column display={meta.reportTypeName} />
                                    <NeoGrid.Column display={meta.entity} />
                                    {hasDescriptions && <NeoGrid.Column display={meta.description} />}
                                    <NeoGrid.Column display={meta.letterCount} />
                                    <NeoGrid.ButtonColumn>
                                        <Neo.Button icon="plus" onClick={() => viewModel.beginCreateAuthorisationBatch(item)}></Neo.Button>
                                    </NeoGrid.ButtonColumn>
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>}

                    {!viewModel.taskRunner.isBusy && viewModel.criteria.reportType && viewModel.suggested.length === 0 && 
                        <Neo.Alert variant="info" className="mb-0">
                            No records found for the selected criteria.
                        </Neo.Alert>}
                </Neo.Card>

                <Neo.Modal 
                    title="Create Authorisation Batch"
                    bindModel={viewModel.meta.createCommand}
                    acceptButton={{ text: "Create", icon: "plus", onClick: () => this.createAuthorisationBatch()}}
                    closeButton={false}>
                    {(command: CreateLetterAuthorisationBatchCommand) => (
                        <div>
                            {!command.criteria.hasDifferentDates &&
                                <Neo.FormGroup label="Record Date" display={command.criteria.meta.endDate} />}

                            {command.criteria.hasDifferentDates &&
                                <>
                                    <Neo.FormGroup display={command.criteria.meta.startDate} />
                                    <Neo.FormGroup display={command.criteria.meta.endDate} />
                                </>}                            

                            <Neo.FormGroup display={command.lookup.meta.reportTypeName} />
                            <Neo.FormGroup display={command.lookup.meta.entity} />
                            {command.lookup.description &&
                                <Neo.FormGroup display={command.lookup.meta.description} />}

                            <Neo.FormGroup label="Allowed Signatories">
                                <Neo.AutoCompleteDropDown 
                                    bindItems={command.meta.signatoryNames} 
                                    bindIds={command.meta.signatories}
                                    items={viewModel.dataCache.letterAuthorisationSignatories}
                                    isOptionSelected={command.maximumSignatories === 0 ? undefined : () => false} />
                            </Neo.FormGroup>
                        </div>
                    )}
                </Neo.Modal>
            </div>
        );
    }

    private async createAuthorisationBatch() {
        const viewModel = this.props.viewModel;

        if (viewModel.createCommand) {
            const batchId = await viewModel.createAuthorisationBatch(viewModel.createCommand);
            this.props.onBatchCreated(batchId);
        }
    }
}